import script from "./DocumentViewerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentViewerModal.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentViewerModal.vue?vue&type=style&index=0&id=3cae8846&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cae8846"]])

export default __exports__